var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "devices",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 22,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68289 18.6016L11.2432 20.3179C11.6571 20.7733 12.3258 20.7733 12.7398 20.3179L14.3001 18.6016C14.7989 18.0528 14.6928 17.1071 14.0559 16.7452C12.761 16.0096 11.2113 16.0096 9.90579 16.7452C9.30078 17.1071 9.18402 18.0528 9.68289 18.6016Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72378 14.2466C6.24388 14.8187 7.06117 14.8771 7.66618 14.3984C10.256 12.3785 13.7375 12.3785 16.3274 14.3984C16.9324 14.8654 17.7497 14.8187 18.2698 14.2466L18.2804 14.2349C18.9172 13.5344 18.8748 12.3435 18.1424 11.7714C14.4911 8.86412 9.51305 8.86412 5.85115 11.7714C5.11877 12.3551 5.07631 13.5344 5.72378 14.2466Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44626 9.54127C1.98759 10.1367 2.84734 10.1951 3.43112 9.65803C8.38796 5.17459 15.5844 5.17459 20.5519 9.64635C21.1462 10.1834 22.0166 10.1367 22.5579 9.54127C23.1842 8.85241 23.1417 7.7082 22.4518 7.08939C16.3911 1.63687 7.62373 1.63687 1.5524 7.08939C0.862478 7.69652 0.809407 8.84074 1.44626 9.54127Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#devices)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.9fb45969.svg";
export { ForwardRef as ReactComponent };